import type { UNITS } from '@/app/common/measures/types.ts';
import { DISTANCE_UNITS } from '@/app/common/measures/types.ts';

export const isShortDistance = (value: number, unit: UNITS) => {
  if (unit === DISTANCE_UNITS.KM) return value < 1; // if more than 1 kilometer => keep in kilometers, if less than 1 km => meters
  if (unit === DISTANCE_UNITS.M) return value < 1000; // if more than 1000 meters => kilometers, if less, if less than 1000 m => m
  if (unit === DISTANCE_UNITS.FT) return value < 500; // if more than 500 feet => miles, if less than 500 ft => feet
  if (unit === DISTANCE_UNITS.MI) return value < 0.1; // if more than 0.1 miles => miles, if less than 0.1 mi => feet
  return false; // Default case, assume not short distance
};
